import {Sensor} from "@core/model";
import {FilterList} from "@mui/icons-material";
import {
  Box,
  Chip,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import {renderAssetTypeIcon, translate, truncateSx} from "@util";
import {useState} from "react";

const SensorSelector = ({
  sensors,
  selected,
  collapse = false,
  handleChange,
}: {
  sensors: Sensor[];
  selected: Sensor[];
  collapse?: boolean;
  handleChange: (s: Sensor, checked: boolean) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  if (collapse) {
    return (
      <Box className="filter-list-menu">
        <IconButton size="small" onClick={e => setAnchorEl(e.currentTarget)}>
          <FilterList />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}>
          {sensors.map(s => (
            <MenuItem
              key={`selector-li-${s.id}`}
              selected={selected.map(sel => sel.id).includes(s.id)}
              onClick={() =>
                handleChange(s, !selected.map(sel => sel.id).includes(s.id))
              }>
              <ListItemIcon>
                {renderAssetTypeIcon(s.type, "inherit", "inherit")}
              </ListItemIcon>
              <ListItemText sx={truncateSx}>
                {translate(`entity.sensor.${s.name}`, s.name)}
              </ListItemText>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  return (
    <Stack
      className="hide-sm-scroll"
      direction={"row"}
      minHeight={48}
      gap={1}
      mb={1}
      sx={{
        overflowX: "auto",
        overflowY: "hidden",
      }}>
      {sensors.map(s => (
        <Stack
          height={40}
          key={`selector-${s.id}`}
          direction={"row"}
          alignItems={"center"}>
          <Chip
            label={
              <Stack direction={"row"} alignItems={"center"} gap={1}>
                {translate(`entity.sensor.${s.name}`, s.name)}
                {renderAssetTypeIcon(s.type, "inherit", "inherit")}
              </Stack>
            }
            onClick={() =>
              handleChange(s, !selected.map(sel => sel.id).includes(s.id))
            }
            color={
              selected.map(sel => sel.id).includes(s.id) ? "primary" : "default"
            }
          />
        </Stack>
      ))}
    </Stack>
  );
};

export {SensorSelector};
